/**
 * Em que pé está uma data de vencimento (#363) — a regra única que a lista e a ficha leem, para
 * que o mesmo equipamento não diga "1ª inspeção, em 5 dias" numa tela e "Vence em 5 dias" na outra.
 * O estado de CADA data (`dues.<campo>.state`) e os dias vêm do servidor, que decide o limite de
 * 30 dias; aqui só se decide qual frase vale, sem conta de data no navegador.
 *
 * Precedência: vencido, depois a vencer (o estado do servidor), depois a primeira inspeção de um
 * equipamento ainda sem nenhuma, depois em dia. A vencer ganha da primeira inspeção porque é o
 * que o chip de situação ao lado já diz, e as duas telas precisam concordar com ele.
 */
import type { FireDueField, FireEquipment } from '../../types/fireEquipment';

export type DueState = 'VENCIDO' | 'A_VENCER' | 'PRIMEIRA_INSPECAO' | 'EM_DIA';

export function dueState(equipment: FireEquipment, field: FireDueField): DueState {
  const state = equipment.dues[field]?.state;
  if (state === 'VENCIDO') return 'VENCIDO';
  if (state === 'A_VENCER') return 'A_VENCER';

  if (field === 'nextInspection' && !equipment.lastInspectionDate) return 'PRIMEIRA_INSPECAO';
  return 'EM_DIA';
}
